/**
 * Given a numeric value, formats it as a percentage (e.g., 1234 becomes 1,234%).
 * @param {number} value - The number to format as a percentage.
 * @returns {string} The formatted value.
 */
const formatPercentage = (value) => (typeof value === 'number' && !Number.isNaN(value)
  ? value.toLocaleString('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'percent',
  }) : 'N/A');

export default formatPercentage;
